var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCreateBrokerAccBg = function SvgCreateBrokerAccBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 900,
    viewBox: "0 0 563 900",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.864 -190L385.335 -116.5C452.807 -43 526.512 104 553.5 251C580.489 398 544.5 539 466.301 692C389 837.5 263.886 986 236.898 1133C209.909 1280 263.886 1427 290.875 1500.5L317.864 1574L-5.99983 1574L-5.99983 1500.5C-5.99983 1427 -5.99982 1280 -5.99981 1133C-5.99981 986 -5.9998 839 -5.99979 692C-5.99979 545 -5.99978 398 -5.99978 251C-5.99977 104 -5.99976 -43 -5.99976 -116.5L-5.99976 -190L317.864 -190Z",
    fill: "#22635E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateBrokerAccBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/createBrokerAccBg.2a31d8bc.svg";
export { ForwardRef as ReactComponent };